import { render, staticRenderFns } from "./PWEdit.vue?vue&type=template&id=52c0fa88&scoped=true"
import script from "./PWEdit.vue?vue&type=script&lang=ts"
export * from "./PWEdit.vue?vue&type=script&lang=ts"
import style0 from "./PWEdit.vue?vue&type=style&index=0&id=52c0fa88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c0fa88",
  null
  
)

export default component.exports